function cov_lxboga4a4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SinkFilled.tsx";
  var hash = "80ddd2d75653944505b479130b43a74b84e078ea";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SinkFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "80ddd2d75653944505b479130b43a74b84e078ea"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_lxboga4a4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_lxboga4a4();
var Icon = (cov_lxboga4a4().s[0]++, {
  name: 'sink-filled',
  svg: "<path d=\"M10.25 1.75C8.317 1.75 6.75 3.317 6.75 5.25V6.75H9.25V5.25C9.25 4.69772 9.69772 4.25 10.25 4.25C10.8023 4.25 11.25 4.69772 11.25 5.25V11.75H9.25V10C9.25 9.30964 8.69036 8.75 8 8.75C7.30964 8.75 6.75 9.30964 6.75 10V11.75H3C2.30964 11.75 1.75 12.3096 1.75 13C1.75 13.6904 2.30964 14.25 3 14.25H4.00383C4.13591 18.5526 7.66536 22 12 22C16.3346 22 19.8641 18.5526 19.9962 14.25H21C21.6904 14.25 22.25 13.6904 22.25 13C22.25 12.3096 21.6904 11.75 21 11.75H18.25V10C18.25 9.30964 17.6904 8.75 17 8.75C16.3096 8.75 15.75 9.30964 15.75 10V11.75H13.75V5.25C13.75 3.317 12.183 1.75 10.25 1.75Z\" fill=\"currentColor\"/>"
});
export default Icon;